<template>
  <section id="contact" class="contact-section">
    <div class="contact-container">
      <h2>{{ $t('contact.title') }}</h2>      
      <form @submit.prevent="sendEmail" class="clean-form">
        <div class="input-group">
          <input type="text" id="name" v-model="name" required placeholder=" " />
          <label for="name">{{ $t('contact.name') }}</label>
        </div>
        
        <div class="input-group">
          <input type="email" id="email" v-model="email" required placeholder=" " />
          <label for="email">{{ $t('contact.address') }}</label>
        </div>
        
        <div class="input-group">
          <textarea id="message" v-model="message" required placeholder=" "></textarea>
          <label for="message">{{ $t('contact.message') }}</label>
        </div>
        
        <button type="submit" class="submit-btn">
          {{ $t('contact.send') }}
          <span class="icon-plane">✈️</span>
        </button>
      </form>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';

const name = ref('');
const email = ref('');
const message = ref('');

const sendEmail = () => {
  const subject = `Message from ${name.value}`;
  const body = `Name: ${name.value}\nEmail: ${email.value}\n\n${message.value}`;
  const mailtoLink = `mailto:contact@singingmolenbeek.be?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = mailtoLink;
};
</script>

<style scoped>
.contact-section {
  padding: clamp(76px, 8vw, 108px) 20px;
  background: var(--warm-bg);
}

.contact-container {
  max-width: 760px;
  margin: 0 auto;
  text-align: center;
}

.contact-intro {
  color: #666;
  margin-bottom: 40px;
  font-size: 1.1rem;
}

.clean-form {
  padding: clamp(26px, 5vw, 48px);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: var(--shadow-lg);
  text-align: left;
}

.input-group {
  position: relative;
  margin-bottom: 26px;
}

input, textarea {
  width: 100%;
  padding: 17px 16px;
  border: 1.5px solid rgba(38, 57, 77, 0.14);
  border-radius: var(--radius-sm);
  background-color: #fbfaf8;
  font-size: 1rem;
  transition: border-color 0.2s, background-color 0.2s, box-shadow 0.2s;
  outline: none;
  font-family: inherit;
}

textarea {
  min-height: 150px;
  resize: vertical;
}

input:focus, textarea:focus {
  border-color: var(--primary-color);
  background-color: #fff;
  box-shadow: 0 0 0 4px rgba(201, 59, 69, 0.08);
}

label {
  position: absolute;
  left: 16px;
  top: 17px;
  color: var(--muted-color);
  pointer-events: none;
  transition: 0.2s ease all;
  background-color: transparent;
}

/* Floating Label Logic */
input:focus ~ label,
input:not(:placeholder-shown) ~ label,
textarea:focus ~ label,
textarea:not(:placeholder-shown) ~ label {
  top: -10px;
  left: 10px;
  font-size: 0.8rem;
  background-color: #fff;
  padding: 0 5px;
  color: var(--primary-color);
  font-weight: 500;
}

.submit-btn {
  width: 100%;
  min-height: 52px;
  padding: 15px 22px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 999px;
  font-size: 1.1rem;
  font-weight: 750;
  cursor: pointer;
  box-shadow: 0 12px 26px rgba(201, 59, 69, 0.2);
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.submit-btn:hover {
  background-color: var(--primary-dark);
  transform: translateY(-2px);
  box-shadow: 0 16px 32px rgba(201, 59, 69, 0.26);
}

@media (max-width: 600px) {
  .contact-section {
    padding: 60px 15px;
  }
}
</style>
